module.exports = __webpack_public_path__ + "img/pic4.dc8bf8c2.png";